import { HttpResponse } from "@angular/common/http";
import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ReportEvaluationProjectFiltersDTO } from "../../models/export-report.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export class ExportProjectReportUseCase
  implements UseCase<ReportEvaluationProjectFiltersDTO, HttpResponse<Blob>>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(filters: ReportEvaluationProjectFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.repo.exportProjectReport(filters);
  }
}

const exportProjectReportUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new ExportProjectReportUseCase(repo);

export const exportProjectReportUseCaseProvider: Provider = {
  provide: ExportProjectReportUseCase,
  useFactory: exportProjectReportUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
